import React from 'react';
import styles from './CTASection.module.css';

const CTASection = () => {
  return (
    <section className={styles.cta}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.badge}>🍽️ તાજું · શુદ્ધ · ઘરેલું</div>

          <h2 className={styles.title}>
            સ્વાદ જે દિલ જીતી લે! <br />
            <span className={styles.highlight}>ઓર્ડર કરો અમારા ખાસ વાનગીઓ</span>
          </h2>

          <p className={styles.subtitle}>
            Order Now & Enjoy Fresh Homemade Food – Made Daily with Love ❤️
          </p>

          <div className={styles.features}>
            <div className={styles.feature}>
              <span className={styles.icon}>🏡</span>
              <span>100% Homemade</span>
            </div>
            <div className={styles.feature}>
              <span className={styles.icon}>🍲</span>
              <span>Fresh Daily Taste</span>
            </div>
            <div className={styles.feature}>
              <span className={styles.icon}>✨</span>
              <span>Authentic Gujarati Flavours</span>
            </div>
          </div>

          <div className={styles.btnGroup}>
            <a
              href="https://wa.me/918183934567"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.locationBtn}
            >
              <span className={styles.btnIcon}>💬</span>
              Order on WhatsApp
            </a>

            <a href="tel:919601399999" className={styles.callBtn}>
              <span className={styles.btnIcon}>📞</span>
              Call to Order
            </a>
          </div>

          {/* <p className={styles.phone}>📞 +91 96013 99999</p> */}
        </div>

        <div className={styles.decoration}>
          <div className={styles.floatingEmoji}>🍛</div>
          <div className={styles.floatingEmoji}>🥗</div>
          <div className={styles.floatingEmoji}>🫓</div>
          <div className={styles.floatingEmoji}>🍽️</div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
